import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useRevealOnScroll } from "@/hooks/useReveal";
import ApplyHero from "./components/ApplyHero";
import ApplyGuide from "./components/ApplyGuide";
import ApplyForm from "./components/ApplyForm";

export default function Apply() {
  useRevealOnScroll();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <ApplyHero />
        <ApplyGuide />
        <ApplyForm />
      </main>
      <Footer />
    </div>
  );
}